import Serialize from '../utilities/SerializeForm';
import BaseComponent from './BaseComponent';
import { showFieldsErrors, showGlobalError } from '../utilities/FormErros';

export default class BaseFormComponent extends BaseComponent {
  constructor(element) {
    super(element);
  }

  /**
   *
   * @param {CallableFunction} cb - The callback function
   * @return {function}
   */
  onSubmit(cb) {
    return this.$on('bouncerFormValid', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const formButton = e.currentTarget.querySelector('button[type="submit"]');
      const action = e.currentTarget.getAttribute('action');
      this.cleanCustomError();
      const res = await cb(e, action, formButton);
      if (res) this.handleRes(res, formButton);
    });
  }

  handleRes(res, formButton) {
    const {
      error, errorFields, errorMessage, errorMsg
    } = res;
    if (errorFields) {
      showFieldsErrors(this.$el, errorFields);
    }
    const stringError = errorMessage || errorMsg;
    if (stringError) {
      showGlobalError(this.$el, stringError);
    } else if (error) {
      showGlobalError(this.$el, error);
    }

    if (error || errorFields || errorMessage || errorMsg) {
      this.endLoading(formButton);
    }
  }

  cleanCustomError() {
    const errorFields = this.$el.querySelectorAll('.js-error-message');
    const globaError = this.$el.querySelectorAll('.js-form-warning');

    if (globaError.length > 0) {
      [...globaError].forEach((err) => {
        const parent = err.parentElement;
        parent.removeChild(err);
      });
    }
    if (errorFields.length > 0) {
      [...errorFields].forEach((err) => {
        try {
          const parent = err.parentElement;
          parent.classList.remove(err);
          parent.removeChild(err);
          err.removeAttribute('aria-describedby');
          err.removeAttribute('aria-invalid');
        } catch (e) {
          // TODO error...
        }
      });
    }
  }

  /**
   *
   * @param {String} action
   *
   */
  recaptchaClientSide(action) {
    const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
    if (googleRecaptchaClientSide) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(googleRecaptchaClientSide.value, { action }).then((token) => {
          this.$el.innerHTML += `<input type="hidden" name="googleRecaptchaToken" value="${token}">`;
          this.$el.innerHTML += `<input type="hidden" name="googleRecaptchaAction" value="${action}">`;
        });
      });
    }
  }


  /**
   *
   * @param {HTMLFormElement} form
   * @return {SerializeForm}
   */
  serializeForm(form) {
    return new Serialize(form);
  }
}
